// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"0d9d5357","311":"b4d7e2ea","726":"4f2c40eb","787":"19017279"}[chunkId] + ".chunk.js";
};